// DOM query utilities
export const getMathElements = (): NodeListOf<Element> => {
  return document.querySelectorAll('.math, [data-math], mjx-container');
};

export const getUnrenderedMathElements = (): NodeListOf<Element> => {
  // Find math elements that haven't been processed by MathJax yet
  // MathJax creates mjx-container elements, so we look for math-content that doesn't have them
  const allMathElements = document.querySelectorAll('.math-content, [data-math]');
  const unrenderedElements: Element[] = [];
  
  allMathElements.forEach(element => {
    const hasMathJaxContainer = element.querySelector('mjx-container') !== null;
    const isMathJaxContainer = element.tagName === 'MJX-CONTAINER';
    
    if (!hasMathJaxContainer && !isMathJaxContainer) {
      unrenderedElements.push(element);
    }
  });
  
  return unrenderedElements as unknown as NodeListOf<Element>;
};

export const getFormulaCount = (): number => {
  return getMathElements().length;
};